import { DocumentContext } from "./document-context";
import { descriptionItem, section } from "./generic";

export function residentSection(
	ctx: DocumentContext,
	data: { title: string; resident: { firstName: string; lastName: string } },
) {
	return section({
		title: data.title,
		content: {
			columnGap: 12,
			columns: [
				{
					width: "*",
					stack: descriptionItem({
						term: ctx.t("domain-model.resident.property.lastName.label"),
						content: data.resident.lastName,
					}),
				},
				{
					width: "*",
					stack: descriptionItem({
						term: ctx.t("domain-model.resident.property.firstName.label"),
						content: data.resident.firstName,
					}),
				},
			],
		},
	});
}
